<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <transition name="fade">
          <b-card no-body>
            <div slot="header">
              Users
              <div class="card-header-actions">
                <b-button type="button" @click="initModal" v-b-modal.userModal v-b-modal.modal-center size="sm" variant="primary"><i class="fa fa-bell-o"></i> Request</b-button>
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <user-table ref="form" :selectedAgencyId="agencyId"></user-table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- MODAL Users -->
    <b-modal centered id="userModal" size="lg" ref="userModal" title="List of Agencies Requesting Access" class="modal-primary" ok-title="Close" ok-only>
      <b-row>
        <b-col sm="12">
          <b-form>              
              <!-- <b-row>  
                <b-col sm="4">
                   <b-form-group class="required">
                      <label>New Users</label>
                  </b-form-group>
                </b-col>
              </b-row> -->
              <b-row>
                <b-col sm="12">
                    <b-table hover="hover" small="small" striped="striped" bordered="bordered" responsive="sm" 
                      ref="table"
                      :items="myProvider" 
                      :fields="fields" 
                      :current-page="currentPage" 
                      :per-page="perPage"
                      @filtered="onFiltered" 
                      :filter="filter"
                      sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      :busy.sync="isBusy"
                      :no-provider-paging="noProviderPaging"
                      :no-provider-filtering="noProviderFiltering"
                      :no-provider-sorting="noProviderSorting">

                    <template slot="agency_name" slot-scope="data">
                      <b-link @click="agencyEventHandler(data.item.agency_id)">{{data.item.agency_name}}</b-link>
                    </template>
                    <!-- <template slot="last_update" slot-scope="data">
                      {{data.item.last_update | formatDate('DD/MM/YYYY HH:mm:ss')}} 
                    </template> -->
                    <!-- <template slot="active" slot-scope="data">
                      <b-badge :variant="getBadge(data.item.active)">{{data.item.active ? 'Active' : 'InActive' }}</b-badge>
                    </template> -->
                    <!-- <template slot="action" slot-scope="data" style="width:10px">
                            <b-dropdown class="float-right" variant="transparent text-muted p-0" right no-caret>
                              <template slot="button-content">
                                <i class="icon-settings"></i>
                              </template>
                              <b-dropdown-item @click="editEventHandler(data.item.id, data.item.request_type_id)" :disabled="validateStatusId(data.item)"> Edit</b-dropdown-item>
                              <b-dropdown-item @click="deleteEventHandler(data.item)" v-b-modal.confirmDeleteModal v-b-modal.modal-center :disabled="validateStatusId(data.item)" title="Delete notification"> Delete</b-dropdown-item>
                            </b-dropdown>
                    </template> -->
                  </b-table>
                  <nav>
                    <b-pagination size="sm" :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" prev-text="Prev" next-text="Next" />
                  </nav>
                </b-col>
              </b-row>
          </b-form>
        </b-col>
      </b-row>      
    </b-modal>
    <!--// MODAL Convoy -->

  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import { mapGetters } from 'vuex'
import ReceivedChart from '@/components/dashboard/ReceivedChart'
import SubmittedChart from '@/components/dashboard/SubmittedChart'
import PendingEhocChart from '@/components/dashboard/PendingEhocChart'
import PendingAgencyChart from '@/components/dashboard/PendingAgencyChart'
import CancelledChart from '@/components/dashboard/CancelledChart'

import DashboardChart from '@/components/dashboard/DashboardChart'

import CardLine2ChartExample from '@/components/dashboard/CardLine2ChartExample'
import CardLine3ChartExample from '@/components/dashboard/CardLine3ChartExample'
import CardBarChartExample from '@/components/dashboard/CardBarChartExample'
import MainChartExample from '@/components/dashboard/MainChartExample'
import SocialBoxChartExample from '@/components/dashboard/SocialBoxChartExample'
import CalloutChartExample from '@/components/dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'
import UserTable from '@/components/user/UserTable.vue'
import UserService from '@/api/UserService'
import Api from '@/api/Api'
import toast from '@/mixins/toast'

export default {
  name: 'dashboard',
  components: {
    Callout,
    ReceivedChart,
    SubmittedChart,
    PendingEhocChart,
    PendingAgencyChart,
    CancelledChart,
    UserTable,
    DashboardChart,
  },
  
  computed: {
    ...mapGetters({
      
    })
  },
  data: function () {
    return {     
        agencyId: 0,
        fields: [
          {label:'Agency', key: 'agency_name', sortable: true},
          {label:'Total', key: 'total', sortable: true}
        ],
        selectedItem: null,
        selectedStatusId: 0,
        message: null,
        currentPage: 1,
        perPage: 10,
        selectedItem: null,
        selectedStatusId: 0,
        message: null,
        pageOptions: [ 5, 10, 15 ],
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        isBusy: false,
        noProviderPaging: false,
        noProviderFiltering: false,
        noProviderSorting: false,
        totalRows: 0
    }
  },
  methods: {

    initModal() {


    },

    agencyEventHandler(id) {

      this.agencyId = id

      this.$refs.userModal.hide()

      this.$refs.form.agencyChangeHandler(id)

    },

    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },

    submitModalEventHandler() {

    },

    getColor: function(value) {
      let obj = this.$_.find(constants.STATUS_COLOR_CODES, {id:value})
      return obj.color;
    },

    myProvider (ctx) {

      console.log("** myProvider **")
      let _self = this

      ctx.searchField = this.sortBy
      let offset = ctx.perPage * (ctx.currentPage-1)      
      let promise = Api().get('/users/inactive/list?keyword='+ (ctx.filter ? ctx.filter : '') +
                              '&field='+ ctx.searchField +
                              '&sortby='+  (ctx.sortBy ? ctx.sortBy : 'id') +
                              '&sortdesc='+ ctx.sortDesc +
                              '&offset='+ offset +
                              '&limit='+ ctx.perPage)

      // Must return a promise that resolves to an array of items
      return promise.then((response) => {
        // Pluck the array of items off our axios response
        let items = response.data.items
        _self.totalRows = response.data.total_records

        console.log('totalRows = '+ _self.totalRows)
        // Must return an array of items or an empty array if an error occurred
        return(items || [])
      })
      .catch( error => {
            if (error.response) {
                  if (error.response.status = 401) {
                      toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                      this.$router.replace('/login')
                  } 
                  else  {
                      toast.error( error.response.message, "Error")                      
                  }
                } else if (error.request) {
                  console.log(error.request)                      
                  toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                } else {
                  // Something happened in setting up the request that triggered an Error
                  console.log('Error', error.message);                      
                }
        })
    },

    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    getBadge (status) {
      return status === true ? 'success' : 'danger'
    },

    getRowCount (items) {
      return items.length
    }

  },

  created () {
      this.agencyId = this.$store.state.agencyId            
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/UserList.vue